module.exports = __webpack_public_path__ + "img/9788946046818.1ef23a56.jpg";